import React from 'react'

import NotificationConsentBanner from '../../molecules/NotificationConsentBanner'
import SideNav from '../../organisms/SideNav'
import TopMenu from '../../organisms/TopMenu'
import MobileFooter from '../../organisms/MobileFooter'

import { useMenuVisibility } from '../../../providers/MenuVisibilityProvider'
import { useBreakpoint } from '../../../providers/BreakpointProvider'
import { useNoteVisibility } from '../../../providers/NoteVisibilityProvider'
import useDetectKeyboardOpen from '@SonarCX/hooks/useDetectKeyboardOpen'
import useStyles from './styles'

export type AgentPageProps = {
  statsComponent?: React.ReactNode
  rootRef?: React.MutableRefObject<HTMLDivElement>
  scroll?: boolean
  hideMobileFooter?: boolean
  centerContent?: boolean
  disablePadding?: boolean
  disableBottomPadding?: boolean
  children: React.ReactNode
}

const AgentPage: React.FC<AgentPageProps> = ({
  statsComponent,
  rootRef,
  scroll,
  hideMobileFooter,
  centerContent,
  disablePadding,
  disableBottomPadding,
  children
}) => {
  const { visible } = useMenuVisibility()
  const { isSmall, isNotMedium } = useBreakpoint()
  const { modalWidth, open } = useNoteVisibility()
  const isKeyboardOpen = useDetectKeyboardOpen()

  const pageWidth = open ? modalWidth : null

  const classes = useStyles({
    scrollbar: Boolean(scroll),
    smallMedia: isSmall,
    hideMobileFooter,
    centerContent,
    disablePadding,
    pageWidth,
    isKeyboardOpen
  })

  return (
    <>
      <NotificationConsentBanner />

      <div ref={rootRef} id='agentPage' className={classes.root}>
        {isNotMedium && <SideNav />}

        <div className={classes.contentArea}>
          {visible && <TopMenu statsComponent={statsComponent} />}

          <div
            className={classes.mainContent}
            style={disableBottomPadding ? { paddingBottom: 0 } : {}}
          >
            {children}
          </div>
        </div>
      </div>

      {isSmall && !hideMobileFooter && <MobileFooter />}
    </>
  )
}

export default AgentPage
